import React, { Component } from "react";
import { GOOGLE_API_KEY } from "../../../../config/Keys";
import GeoLocation from "../../../vendorOnboradingComponents/allScreens/MapSetup/GeoLoaction";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  getArea,
  getCity,
  getState,
  GetAddressFromLatLng,
  getPinCode,
} from "../../../vendorOnboradingComponents/allScreens/MapSetup/MapUtils";
import VendorMapSetupScreenTwoWrapper from "./VendorMapSetupScreenTwoWrapper";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
// import { Alert } from "@material-ui/lab";
import Alert from "react-s-alert";

//AIzaSyBQwWgamVVVvBLQ4qoAlyRTD4kKaC6t35o
// AIzaSyBKaOKvpvylo_hx-icZWxmjtQB6WJAk1Hs
const google_API_Key = GOOGLE_API_KEY;

export class VendorMapSetupEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      id: "",
      selectedTab: 1,
      google_place_id: "",
      restaurant_address: "",
      city: "",
      area: "",
      state: "",
      pinCode: "",
      location: {
        // latitude: "",
        // longitude: "",
        type: "Point",
        coordinates: ["", ""],
      },
      hasSetMapProps: false,
      errors: {},
    };
  }

  componentDidMount() {
    if (
      Object.keys(this.props.errors).length > 0 &&
      this.props.errors !== this.state.errors
    ) {
      this.setState({
        errors: this.props.errors,
      });
    }
    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
    if (
      this.props.onboarding._id &&
      !isEmpty(this.props.onboarding.location) &&
      !isEmpty(this.props.onboarding.location.coordinates)
    ) {
      this.onGetGeoCodetoState(
        // this.props.onboarding.location.latitude,
        // this.props.onboarding.location.longitude
        this.props.onboarding.location.coordinates[1],
        this.props.onboarding.location.coordinates[0]
      );
    } else if (
      this.props.location.state !== null &&
      this.props.location.state !== undefined
    ) {
      this.onGetGeoCodetoState(
        this.props.location.state.location.lat,
        this.props.location.state.location.lng
      );
    } else {
      this.onGetGeoCodetoState(18.5132515, 73.937661);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.onboarding._id &&
        !isEmpty(this.props.onboarding.location) &&
        !isEmpty(this.props.onboarding.location.coordinates) &&
        !isEmpty(this.state.location.coordinates)) ||
      prevState.location.coordinates !== this.state.location.coordinates
    ) {
      this.onGetGeoCodetoState(
        this.state.location.coordinates[0],
        this.state.location.coordinates[1]
      );
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    if (
      nextProps.onboarding._id &&
      !isEmpty(nextProps.onboarding.location) &&
      !isEmpty(nextProps.onboarding.location.coordinates)
    ) {
      if (
        !isEmpty(nextProps.onboarding.location.coordinates[1]) &&
        !isEmpty(nextProps.onboarding.location.coordinates[0]) &&
        !nextState.hasSetMapProps
      ) {
        return {
          location: {
            coordinates: [
              nextProps.onboarding.location.coordinates[1],
              nextProps.onboarding.location.coordinates[0],
            ],
          },
          hasSetMapProps: true,
        };
      }
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    return null;
  }

  onGetGeoCodetoState = async (lat, lng) => {
    let response = await GetAddressFromLatLng(lat, lng);
    // console.log(response);
    let location = {
      type: "Point",
      coordinates: [lat, lng],
      // latitude: lat,
      // longitude: lng,
    };
    this.setState({
      google_place_id: response.place_id,
      restaurant_address: response.address,
      area: response.area,
      city: response.city,
      state: response.state,
      pinCode: response.pinCode,
      location: location,
    });
  };

  onAutoDetectHandler = async (e) => {
    let location = await GeoLocation(window.navigator);
    this.onGetGeoCodetoState(location.lat, location.lng);
    this.setState({
      editButton: true,
      actionButton: true,
    });
  };

  onWhitOutApiCall = (e) => {
    this.props.history.push("/seatingdashboard");
  };

  editClick = (e) => {
    this.setState({
      editButton: true,
      actionButton: true,
    });
  };

  onSubmitHandler = (e) => {
    if (this.props.onboarding._id) {
      let formData = {
        id: this.props.onboarding._id,
        google_place_id: this.state.google_place_id,
        restaurant_address: this.state.restaurant_address,
        city: this.state.city,
        area: this.state.area,
        pinCode: this.state.pinCode,
        location: {
          type: "Point",
          coordinates: [
            this.state.location.coordinates[1],
            this.state.location.coordinates[0],
          ],
        },
      };
      // console.log(formData);
      this.props.create_and_update_restaurant(formData, this.onSuccess);
    }
    // create_and_update_restaurant
  };

  onSuccess = (e) => {
    this.setState({
      actionButton: false,
    });
    Alert.success(`<h4>Map Details Up Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  // *********************** MAP METHODS
  onMarkerDragEnd = async (event) => {
    this.onGetGeoCodetoState(event.latLng.lat(), event.latLng.lng());
    this.setState({
      actionButton: true,
    });
  };

  onPlaceSelected = (place) => {
    let location = {
      type: "Point",
      coordinates: [
        place.geometry.location.lat(),
        place.geometry.location.lng(),
      ],
      // latitude: place.geometry.location.lat(),
      // longitude: place.geometry.location.lng(),
    };
    this.setState({
      google_place_id: place.place_id ? place.place_id : "",
      restaurant_address: place.formatted_address
        ? place.formatted_address
        : "",
      area: getArea(place.address_components),
      city: getCity(place.address_components),
      state: getState(place.address_components),
      pinCode: getPinCode(place.address_components),
      location: location,
      actionButton: true,
    });
  };

  onInfoWindowClose = (event) => {};

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.state.location.latitude !== nextState.location.latitude ||
      this.state.location.longitude !== nextState.location.longitude ||
      this.state.google_place_id !== nextState.google_place_id ||
      this.state.restaurant_address !== nextState.restaurant_address ||
      this.state.city !== nextState.city ||
      this.state.area !== nextState.area ||
      this.state.state !== nextState.state ||
      this.state.loader !== nextState.loader ||
      this.state.editButton !== nextState.editButton
    ) {
      return true;
    } else {
      return false;
    }
  }

  localProps = {
    editClick: this.editClick,
    onWhitOutApiCall: this.onWhitOutApiCall,
    onAutoDetectHandler: this.onAutoDetectHandler,
    onSubmitHandler: this.onSubmitHandler,
    onMarkerDragEnd: this.onMarkerDragEnd,
    onPlaceSelected: this.onPlaceSelected,
    onInfoWindowClose: this.onInfoWindowClose,
  };

  render() {
    // if (this.state.errors.code !== undefined) {
    //   Alert.success(`<h4>${this.state.errors.message}</h4>`, {
    //     position: "top-right",
    //     effect: "bouncyflip",
    //     beep: true,
    //     html: true,
    //     timeout: 3000,
    //     offset: 35,
    //   });
    // }
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    // let { latitude, longitude } = this.state.location;
    // latitude = parseFloat(latitude);
    // longitude = parseFloat(longitude);
    // this.localProps.state = this.state;
    let latitude = this.state.location.coordinates[0];
    let longitude = this.state.location.coordinates[1];
    latitude = parseFloat(latitude);
    longitude = parseFloat(longitude);
    this.localProps.state = this.state;
    return (
      <VendorMapSetupScreenTwoWrapper
        localProps={this.localProps}
        state={this.state}
      >
        {latitude !== "" &&
        latitude !== undefined &&
        longitude !== "" &&
        longitude !== undefined ? (
          <DisplayMap localProps={this.localProps} />
        ) : null}
      </VendorMapSetupScreenTwoWrapper>
    );
  }
}

VendorMapSetupEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorMapSetupEdit));

export const DisplayMap = (props) => {
  const localProps = props.localProps;
  const { state } = props.localProps;
  const mapHeight = "65vh";
  const mapZoom = 15;
  const mapRadius = 20000;
  const AsyncMap = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        google={props.google}
        defaultZoom={mapZoom}
        defaultCenter={{
          lat: parseFloat(state.location.coordinates[0]),
          lng: parseFloat(state.location.coordinates[1]),
        }}
        radius={mapRadius}
      >
        {/* For Auto complete Search Box */}
        <div style={{ position: "absolute", top: "0", width: "100%" }}>
          <Autocomplete
            style={{
              border: "none",
              borderRadius: "5px",
              boxShadow: "0px 0px 10px #0000001A",
              width: "100%",
              height: "7vh",
              paddingLeft: "10px",
            }}
            disabled={state.editButton === false ? true : false}
            onPlaceSelected={localProps.onPlaceSelected}
            types={[]}
          />
        </div>

        <InfoWindow
          onClose={localProps.onInfoWindowClose}
          position={{
            lat: parseFloat(state.location.coordinates[0]) + 0.0014,
            lng: parseFloat(state.location.coordinates[1]),
          }}
        >
          <div>
            <p style={{ marginBottom: "10px" }}>
              <span style={{ color: "#ff4d2d" }}>Address: </span>
              <span
                style={{
                  padding: "0",
                  margin: "0",
                }}
              >
                {state.restaurant_address}
              </span>
            </p>
            <p style={{ marginBottom: "20px" }}>
              <span style={{ color: "#ff4d2d" }}>PlaceId: </span>
              <span
                style={{
                  padding: "0",
                  margin: "0",
                }}
              >
                {state.google_place_id}
              </span>
            </p>
            <div className="d-flex row">
              <p className="col" style={{ marginBottom: "10px" }}>
                <span style={{ color: "#ff4d2d" }}>Latitude: </span>
                <span
                  style={{
                    padding: "0",
                    margin: "0",
                  }}
                >
                  {state.location.coordinates[0]}
                </span>
              </p>
              <p className="col" style={{ marginBottom: "10px" }}>
                <span style={{ color: "#ff4d2d" }}>Longitude: </span>
                <span
                  style={{
                    padding: "0",
                    margin: "0",
                  }}
                >
                  {state.location.coordinates[1]}
                </span>
              </p>
            </div>
          </div>
        </InfoWindow>

        <Marker
          // google={props.google}
          name={"Dolores park"}
          draggable={state.editButton === true ? true : false}
          onDragEnd={localProps.onMarkerDragEnd}
          position={{
            lat: parseFloat(state.location.coordinates[0]),
            lng: parseFloat(state.location.coordinates[1]),
          }}
          icon={{
            url: require("../../../../assets/images/UserManagement/map-pin.svg"),
          }}
        />
        <Marker />
      </GoogleMap>
    ))
  );
  let map;
  if (
    state.location.coordinates[0] !== undefined &&
    state.location.coordinates[1] !== undefined
  ) {
    map = (
      <div>
        <AsyncMap
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${google_API_Key}&libraries=places`}
          loadingElement={
            <div style={{ height: `100%`, position: "absolute" }} />
          }
          containerElement={
            <div
              style={{
                height: mapHeight,
                position: "relative",
                paddingTop: "55px",
                marginBottom: "75px",
              }}
            />
          }
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
    );
  } else {
    map = <div style={{ height: mapHeight }} />;
  }
  return map;
};
